import getDecorators from "inversify-inject-decorators";
import container from "../../../ioc/inversify.config";
import TYPES from "../../../ioc/types";
import { GameStateDTO } from "../../../shared/dtos";
import { DefaultSelectable } from "../../menu/interfaces";
import { GeometryService } from "../../ui-services/geometry-ui-service";
import { TextContent } from "../text-content";

const { lazyInject } = getDecorators(container);

export class LoadingGameCard extends DefaultSelectable {
    @lazyInject(TYPES.GeometryService)
    private geometryService: GeometryService;

    // Card dimensions - centralized definition for both menus
    public static readonly CARD_WIDTH = 120;
    public static readonly CARD_HEIGHT = 120;

    public loadGame: GameStateDTO;

    constructor(
        cardWidth: number,
        cardHeight: number,
        loadGame: GameStateDTO,
        scene: Phaser.Scene
    ) {
        //}, styleOptions?: StyleOptions) {
        super(scene, 0, 0);
        this.width = cardWidth;
        this.height = cardHeight;
        const graphics = this.scene.add.graphics();
        this.add(graphics);
        this.loadGame = loadGame;
        this.geometryService.initGraphicContext(graphics);
        this.createGameCard(loadGame);
    }

    private createGameCard(loadGame: GameStateDTO) {
        let gameSummary;
        let location, gold;
        if (loadGame) {
            // Use backend-provided display fields
            const characterName = loadGame.main_character_name || "Unknown";
            const level = loadGame.main_character_level || 1;

            // Format character info with proper spacing
            gameSummary = new TextContent(this.x, 10, `${characterName} lv ${level}`, this.scene);

            // Use backend-provided scene name
            const sceneName = loadGame.scene_name || loadGame.game_location.scene_id;
            location = new TextContent(this.x, 40, sceneName, this.scene);

            gold = new TextContent(this.x, 70, `${loadGame.gold} G`, this.scene);
        } else {
            // Create "Nouvelle partie" split across two lines for better alignment
            // Using TextContent to maintain consistent styling and enable selection highlighting
            const line1 = new TextContent(0, 0, "Nouvelle", this.scene);
            const line2 = new TextContent(0, 0, "partie", this.scene);

            // Center both lines horizontally and vertically within the card
            const textHeight = line1.height + line2.height;
            const startY = (this.height - textHeight) / 2;

            line1.setPosition((this.width - line1.width) / 2, startY);
            line2.setPosition((this.width - line2.width) / 2, startY + line1.height);

            this.add(line1);
            this.add(line2);
        }

        if (loadGame) {
            this.add(gameSummary);
            this.add(location);
            this.add(gold);
        }
        this.geometryService.drawBox(0, 0, this.width, this.height);
    }
}
